module.exports = __webpack_public_path__ + "img/logo-academia-digital.7517e932.svg";